import type { RouteDefinition } from "@/Routing/KnownRoute";
import { showPairMobileDevice } from "@/Helpers/showPairMobileDevice";
import { ApiAccessScreen } from "@/Features/ApiAccess/ApiAccessScreen";
import { PairMobileDeviceScreen } from "@/Features/PairMobileDevice/PairMobileDeviceScreen";
import BankAccountsScreen from "@/Features/BankAccounts/BankAccountsScreen";
import ShipmentBookedScreen from "@/Features/BookShipment/ShipmentBookedScreen";
import BrokersScreen from "@/Features/Brokers/BrokersScreen";
import { SubmitClaimScreen } from "@/Features/Claims/SubmitClaimScreen";
import ConnectivityTestScreen from "@/Features/ConnectivityTest/ConnectivityTestScreen";
import CreditCardsScreen from "@/Features/CreditCards/CreditCardsScreen";
import ViewInvoicesScreen from "@/Features/Invoices/ViewInvoicesScreen";
import AddressBookScreen from "@/Features/Locations/AddressBookScreen";
import { SavedCommoditiesScreen } from "@/Features/SavedCommodities/SavedCommoditiesScreen";
import { ShipmentDraftsScreen } from "@/Features/ShipmentDrafts/ShipmentDraftsScreen";
import ViewCompanyScreen from "@/Features/ViewCompany/ViewCompanyScreen";
import ViewAllShipmentsScreen from "@/Features/ViewShipments/ViewAllShipmentsScreen";
import ViewShipmentScreen from "@/Features/ViewShipments/ViewShipmentScreen";
import { WebhooksDeliveriesScreen } from "@/Features/Webhooks/WebhooksDeliveriesScreen";
import DashboardScreen from "@/Features/Dashboard/DashboardScreen";
import QuotesScreen from "@/Features/Dashboard/QuotesScreen";

/** Screens that need a signed-in customer. DashboardRouter renders them, and
 *  RouteFallback sends a signed-out visitor to sign-in when they open one. */
export function signedInRoutes(
  userEmail: string | undefined,
): Array<RouteDefinition> {
  return [
    { path: "/", element: <DashboardScreen /> },
    { path: "/quotes", element: <QuotesScreen /> },
    { path: "/view-all-shipments", element: <ViewAllShipmentsScreen /> },
    { path: "/address-book", element: <AddressBookScreen /> },
    { path: "/brokers", element: <BrokersScreen /> },
    { path: "/saved-commodities", element: <SavedCommoditiesScreen /> },
    { path: "/credit-cards", element: <CreditCardsScreen /> },
    { path: "/bank-accounts", element: <BankAccountsScreen /> },
    { path: "/manage-users", element: <ViewCompanyScreen /> },
    { path: "/api-access", element: <ApiAccessScreen /> },
    { path: "/webhook-deliveries", element: <WebhooksDeliveriesScreen /> },
    ...(showPairMobileDevice(userEmail)
      ? [{ path: "/pair-mobile-device", element: <PairMobileDeviceScreen /> }]
      : []),
    { path: "/view-invoices", element: <ViewInvoicesScreen /> },
    { path: "/view-shipment", element: <ViewShipmentScreen /> },
    { path: "/submit-claim", element: <SubmitClaimScreen /> },
    { path: "/booking-success", element: <ShipmentBookedScreen /> },
    { path: "/connectivity-test", element: <ConnectivityTestScreen /> },
    { path: "/drafts", element: <ShipmentDraftsScreen /> },
  ];
}
